module.exports = __webpack_public_path__ + "img/AM.608214ca.svg";